// extracted by mini-css-extract-plugin
export default {"link":"Signup_link__vK9q0","text":"Signup_text__AELwl","terms":"Signup_terms__x2-tV"};